export default __webpack_public_path__ + "static/media/gloves5.fe19c21b.jpg";